import { teApi } from 'yxt-biz-pc/packages/api';

export const getAuditFormInfo = (formId) => {
  return teApi.get(`/pay/Strt/statement/detail4audit/${formId}`);
};
